import { DateUtils } from 'ps-gui';
import { getPhrase } from '../../data/phrases';




export function getLockMessage(lockedFromDate, lockedToDate) {
	let message = null;
	if (DateUtils.isActiveDateRange(lockedFromDate, lockedToDate)) {
		// prave ted je editace labelu uzamcena
		if (lockedToDate) {
			message = getPhrase('labelModuleIsLockedWithToDate').replace('$fromDate', DateUtils.formatDate(lockedFromDate, false)).replace('$toDate', DateUtils.formatDate(lockedToDate, false));
		} else {
			message = getPhrase('labelModuleIsLocked').replace('$fromDate', DateUtils.formatDate(lockedFromDate, false));
		}
	} else if (DateUtils.compareDates(new Date(), lockedFromDate) < 0) {
		if (lockedToDate) {
			message = getPhrase('labelModuleWillBeLockedWithToDate').replace('$fromDate', DateUtils.formatDate(lockedFromDate, false)).replace('$toDate', DateUtils.formatDate(lockedToDate, false));
		} else {
			message = getPhrase('labelModuleWillBeLocked').replace('$fromDate', DateUtils.formatDate(lockedFromDate, false));
		}
	}
	return message;
}